import { Card, Input } from "@";
import type { AdahiSectionProps } from "./types";
import { ProjectType } from "@/features/donations/projects/types.ts";

export const AdahiSection = ({
  watch,
  setValue,
  show,
  adahiProductsOptions,
  adahiRitualOptions,
}: AdahiSectionProps) => {
  if (Number(watch("projectType")) === ProjectType.Meal) {
    return null;
  }
  return (
    <Card isOpen={false} title="أضاحي" className="lg:col-span-2">
      <div className="grid gap-5 md:grid-cols-2">
        <Input
          star
          disabled={!!show}
          label="منتج الأضاحي"
          type="select-searchable"
          list={adahiProductsOptions}
          value={adahiProductsOptions?.filter(
            (c) => watch("adahiProductId") === c.value,
          )}
          change={(e: { value: number } | null) =>
            setValue("adahiProductId", e ? e.value : "")
          }
        />

        <Input
          star
          disabled={!!show}
          label="إجراء الأضاحي"
          type="select-searchable"
          list={adahiRitualOptions}
          value={adahiRitualOptions?.filter(
            (c) => watch("adahiRitualId") === c.value,
          )}
          change={(e: { value: number } | null) =>
            setValue("adahiRitualId", e ? e.value : "")
          }
        />
      </div>
    </Card>
  );
};
